<template>
  <div>
    <b-row>
      <b-col cols="12" v-if="survey_group_options.length > 1">
        <b-form-group
          :label="`${$lang.surveyLang.survey_titer}: `"
          label-for="term"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            v-if="mode === 'add'"
            slot="label"
            :label="`${$lang.surveyLang.survey_titer}: `"
            :rules="$v.survey_group_selected.$params"
          />
          <selectFind
            :options="survey_group_options"
            v-model="$v.survey_group_selected.$model"
            label="caption"
            :loading="survey_group_loading"
            :isValid="
              $v.survey_group_selected.$dirty
                ? !$v.survey_group_selected.$error
                : null
            "
            :disabled="includes(mode, ['edit', 'view'])"
          />
          <b-form-invalid-feedback
            :style="{
              display: $v.survey_group_selected.$error ? 'block' : 'none',
            }"
            id="survey_group_selected_feedback"
          >
            {{ $lang.error_required | replace($lang.surveyLang.survey_titer) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" v-if="survey_group_selected">
        <SurveyGroupParvandehList :code="surveyGroupCode" />
      </b-col>
      <b-col
        cols="12"
        md="12"
        class="mt-3 px-0"
        v-show="survey_parvandeh_selected"
      >
        <UploadFile
          v-if="mode === 'edit'"
          :title="$lang.fileManagers"
          keyServies="survey"
          :keyValue="keyValue"
          :crop="false"
          :parentShowButtons="false"
          :file_types="fileTypes"
          :parentAttachmentTypeId="26"
          attachment_type_name="attachment_type_survey"
          :showForm="false"
          :allowCollapse="false"
          :isCollapseFiles="true"
          :maxUploadFile="10485760"
          :allowFileSize="10240"
          :acceptFormats="acceptFormats"
        />
      </b-col>
      <b-col v-if="survey_group_options.length <= 0">
        <Alert :text="$lang.emptySurveyGroupAlert" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import SurveyGroupParvandehList from "../components/SurveyGroupParvandehList.vue";
import { pathOr, includes } from "ramda";
import { required, maxLength } from "vuelidate/lib/validators";
import UploadFile from "@/components/base/uploadFile";
import { Alert } from "@/components/re-design";

export default {
  validations: {
    survey_group_selected: { required },
    survey_parvandeh_selected: { required },
    survey_text: { required, maxLength: maxLength(190) },
  },
  components: { UploadFile, SurveyGroupParvandehList, Alert },
  props: {
    item: {
      type: Object,
      default: null,
    },
    keyValue: {
      type: [String, Number],
      default: null,
    },
    mode: {
      type: String,
      default: null,
    },
    runFinalSave: {
      type: Boolean,
      default: false,
    },
    resetForm: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      survey_group_selected: null,
      survey_group_options: [],
      survey_group_loading: false,
      survey_parvandeh_selected: null,
      survey_parvandeh_options: [],
      survey_parvandeh_loading: false,
      survey_text: null,
      azmoonData: [],
      extraData: {},
      azmoonLoading: false,
      acceptFormats: [
        {
          caption: "عکس",
          value: "10MB",
        },
        {
          caption: "مجموعه آفیس",
          value: "20MB",
        },
        {
          caption: "ویدیو/صوت",
          value: "50MB",
        },
        {
          caption: "بقیه فایل‌ها",
          value: "10MB",
        },
      ],
      fileTypes: ["image", "office", "media", "other"],
    };
  },
  computed: {
    surveyGroupCode() {
      return pathOr(null, ["id"], this.survey_group_selected);
    },
  },
  watch: {
    item(value) {
      value && this.fetchData();
    },
    resetForm(value) {
      value && this.resetFormData();
    },
  },
  created() {
    this.mode === "add" && this.getGroupCombo();
  },
  methods: {
    pathOr,
    includes,
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;
      let payload = {
        survey_group_code: pathOr(null, ["id"], this.survey_group_selected),
        person_parvandeh_code: pathOr(
          null,
          ["id"],
          this.survey_parvandeh_selected
        ),
        survey_text: this.survey_text,
      };
      this.$emit("submit", payload);
    },
    close() {
      this.$emit("close");
    },
    resetFormData() {
      this.survey_group_selected = null;
      this.survey_parvandeh_selected = null;
      this.survey_parvandeh_options = [];
      this.survey_text = null;
      this.azmoonData = [];
      this.extraData = {};
      this.$v.$reset();
    },
    async getGroupCombo() {
      try {
        this.survey_group_loading = true;
        const url = `${this.$config.api_url}${this.$config.survey.mySurveyGroup}`;
        const response = await this.$httpService.get(url);
        const survey_group_options = pathOr([], ["data", "data"], response);
        this.survey_group_options = survey_group_options.map((item) => {
          return {
            caption: `${pathOr("", ["group_number"], item)} - ${pathOr(
              "",
              ["name"],
              item
            )}`,
            id: pathOr(null, ["code"], item),
          };
        });
        this.survey_group_selected =
          this.survey_group_options.length === 1
            ? this.survey_group_options[0]
            : null;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.survey_group_loading = false;
      }
    },
    async getParvandehCombo(query) {
      if (!query || query.length < 2) {
        return;
      }
      if (query.length > 2) {
        this.survey_parvandeh_options = [];
      }

      try {
        this.survey_parvandeh_loading = true;
        const groupId = pathOr(null, ["id"], this.survey_group_selected);
        const url = `${
          this.$config.api_url
        }${this.$config.survey.survey_available_parvandeh_combo.replace(
          "{0}",
          groupId
        )}?search_txt=${query}`;
        const response = await this.$httpService.get(url);
        const survey_parvandeh_options = pathOr([], ["data", "data"], response);
        this.survey_parvandeh_options = survey_parvandeh_options.map((x) => {
          return {
            caption: `${pathOr("", ["person", "name"], x)} ${pathOr(
              "",
              ["person", "family"],
              x
            )} - ${pathOr("", ["person", "national_code"], x)}`,
            id: pathOr("", ["parvandeh", "code"], x),
            parvandeh_number: pathOr("", ["parvandeh", "parvandeh_number"], x),
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.survey_parvandeh_loading = false;
      }
    },
    async getAzmoonCombo(item) {
      try {
        this.azmoonLoading = true;
        const surveyGroupCode = pathOr(
          null,
          ["id"],
          this.survey_group_selected
        );
        const parvandehNumber = pathOr(null, ["parvandeh_number"], item);
        const url = `${
          this.$config.api_url
        }${this.$config.survey.survey_group_azmoon_combo.replace(
          "{0}",
          surveyGroupCode
        )}?parvandeh_number=${parvandehNumber}`;
        const response = await this.$httpService.get(url);
        this.azmoonData = pathOr([], ["data", "data", "azmoon"], response);
        this.extraData = pathOr({}, ["data", "data", "extra"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.azmoonLoading = false;
      }
    },
    async fetchData() {
      if (this.item && Object.keys(this.item).length) {
        this.survey_group_selected = {
          caption: pathOr(null, ["survey_group", "name"], this.item),
          code: pathOr(null, ["survey_group", "code"], this.item),
        };
        this.survey_parvandeh_selected = {
          caption: `${pathOr(null, ["person", "name"], this.item)} ${pathOr(
            null,
            ["person", "family"],
            this.item
          )}`,
          code: pathOr(null, ["person", "code"], this.item),
        };
        this.survey_text = pathOr(null, ["survey_text"], this.item);
        this.azmoonData = pathOr([], ["azmoon"], this.item);
        this.extraData = {
          person_parvandeh_code: pathOr(null, ["parvandeh", "code"], this.item),
          operator_parvandeh_code: pathOr(
            null,
            ["operator", "parvandeh_code"],
            this.item
          ),
          operator_person_code: pathOr(
            null,
            ["operator", "person_code"],
            this.item
          ),
        };
      }
    },
  },
};
</script>
